module.exports = __webpack_public_path__ + "static/media/carouselbanner.b7def08a.png";